import React from "react";
import styles from "./stressDelPortafoglioSuIpotesiLeftTable.module.scss";
import { useTranslation } from "react-i18next";
import { formatItalianNumber } from "utils/formatUtils";

const StressDelPortafolioSuIpotesiLeftTable = ({
  dataItem,
  innerTitle,
  subSection = false,
}) => {
  const { t } = useTranslation();

  if (!dataItem) {
    return null;
  }

  // Use the configuration from dataItem (they should be identical as per your example)
  return (
    <div
      className={`${styles.tableContainer} ${subSection ? styles.subSection : ""
        }`}
    >
      <table className={styles.compareTable}>
        <thead>
          <tr>
            <th className={styles.assetClassHeader}>
              <span className={styles.titleHeader}>{innerTitle}</span>
            </th>
            <th colSpan={2} className={styles.pesoHeader}>
              <span className={styles.titleHeader}>{t("portfolio.rendimento_percentuale")}</span>
            </th>
          </tr>
        </thead>
        <tbody>
          {dataItem.map((row, index) => {
            // Find matching row in dataItem2 by label

            // Get display label from config if available
            const displayLabel = row.label;
            // configData && configData.rows
            //   ? configData.rows[row.label] || row.label
            //   : row.label;

            return (
              <tr key={index}>
                <td className={styles.assetClassCell}>{displayLabel}</td>
                <td
                  className={`${styles.valueCell} ${styles.firstPortfolioValue}`}
                >
                  {formatItalianNumber(row.weight)}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default StressDelPortafolioSuIpotesiLeftTable;
